import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_VERSION } from './router';

menuRegistry.registerMenu([
    {
        parent: 'General',
        key: 'Version',
        name: 'Version',
        icon: 'fas fa-anchor',
        route: { name: ROUTE_NAME_VERSION.INDEX }
    }
]);

export default registerRouteForModule(router);
